module.exports = __webpack_public_path__ + "img/winerackdog06.402c9f54.jpg";